import { useContext, useState } from "react";
import Drawer from "@material-ui/core/Drawer";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";

// utils
import { api } from "bodycodi/cmap/app/js/api";

const ObjectionPopup = ({ seqNewSettlementPayroll, closeAfterAction }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [description, setDescription] = useState("");

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SALARY_OBJECTION_POP",
      open: { salaryObjectionPop: false },
    });
    setDescription("");
  };

  const objectionRequest = () => {
    try {
      api
        .patch("/payroll/settlement/payrolls/objection", {
          seqNewSettlementPayroll,
          objectionMemo: description,
        })
        .then(({ data }) => {
          handleClose();
          closeAfterAction();
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.salaryObjectionPop}
      onClose={handleClose}
      className="picker-pop"
    >
      <PickerHeader title={"이의 제기 신청"} onClose={handleClose} />
      <div className="picker-body salary-objection-pop">
        <textarea
          placeholder={"이의 제기 신청할 내용을 입력해주세요."}
          maxLength={1000}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <div className="bottom-buttons">
          <button className="grey" onClick={handleClose}>
            취소
          </button>
          <button className="red" disabled={!description} onClick={objectionRequest}>
            이의 제기
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default ObjectionPopup;
